import { Navigate, useLocation } from "react-router-dom";
import { useCampusAuth } from "@/contexts/CampusAuth";

/**
 * Protects member-area routes. Redirects to /campus/login if no demo session.
 */
export default function CampusProtectedRoute({ children }) {
  const { user, ready } = useCampusAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="min-h-screen bg-cream-50 grid place-items-center text-sand-600 text-sm">
        Lade …
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/campus/login" replace state={{ from: location }} />;
  }

  return children;
}
